// extracted by mini-css-extract-plugin
module.exports = {"AdvisorPublicPage":"AdvisorPublicPage__AdvisorPublicPage__UtWWT","certificate":"AdvisorPublicPage__certificate__6lHez"};